
import {Component, Vue} from "vue-property-decorator";
import {TaskDurum} from "@/plugins/uyap-plugin/enum/TaskDurum";
import {ITask, ITasks, PlayerDurum, Task} from "@/plugins/uyap-plugin/store/modules/GorevYoneticisiTypes";
import {TaskTuru} from "@/plugins/uyap-plugin/enum/TaskTuru";
import {ProgramPaths} from "@/enum/ProgramPaths";
import {Socket} from "vue-socket.io-extended";
import DeleteDialog from "@/components/dialogs/DeleteDialog.vue";
import TarafKisi from "@/plugins/uyap-plugin/takip_ac/parser/TarafKisi";
import TarafKurum from "@/plugins/uyap-plugin/takip_ac/parser/TarafKurum";
import {TamamlanmayanDosyalarRow} from "@/plugins/uyap-plugin/uyap/TamamlanmayanDosyalar";
import {
  childTasksUrl,
  ebeveynGorevTuru,
  gorevHash,
  hashKaydiniSil,
  HashSilmeTakibi
} from "@/helpers/HashSilmeHelper";

@Component({
  components: {DeleteDialog}
})
export default class MtsTakipHazirlaBetaIslemDetayView extends Vue {
  @Socket('updateTasks')
  onUpdateTask() {
    this.load();
  }

  onFly = false;
  downloading = false;
  ttDownloading = false;
  seciliGorevler = [];
  headers = [
    {text: 'Birim Adı', value: 'birimAdi'},
    {text: 'Alacaklılar', value: 'alacaklilar'},
    {text: 'Borçlular', value: 'borclular'},
    {text: 'Takibe Esas Tutar', value: 'toplamTakibeEsasMiktar'},
    {text: 'Açıklama', value: 'description'},
    {text: 'Durum', value: 'status'}
  ];
  seciliHataliGorevler = [];
  items = [];
  loading = false;
  hataliHeaders = [
    {text: 'Birim Adı', value: 'birimAdi'},
    {text: 'Alacaklılar', value: 'alacaklilar'},
    {text: 'Borçlular', value: 'borclular'},
    {text: 'Takibe Esas Tutar', value: 'toplamTakibeEsasMiktar'},
    {text: 'Açıklama', value: 'description'},
    {text: 'Durum', value: 'status'},
    { text: "İşlemler", value: "actions" }
  ];
  taskDurum = TaskDurum;
  programPaths = ProgramPaths;
  playerDurum = PlayerDurum;
  hashSilme = new HashSilmeTakibi();

  get isFirstTask(): boolean {
    return this.$store.getters.getSiradakiGorevler[0]?.id == this.$route.params.id;
  }

  get paternTask(): ITask {
    let tasks: ITasks = this.$store.getters.getGorevler;
    let allTaskt: Array<ITask> = [...tasks.incomplete_tasks, ...tasks.completed_tasks];
    return allTaskt.find((task: ITask) => task.id == Number(this.$route.params.id)) as ITask;
  }

  // DEV-3302: satırda task_type_id yoksa ödeme görevi kontrolü üst görevin türüne bakar.
  get ebeveynTuru(): number | null {
    return ebeveynGorevTuru(this.$store.getters.getGorevler, this.$route.params.id);
  }

  async mounted() {
    await this.load()
  }

  async load() {
    const sira = this.hashSilme.yuklemeBasladi();
    try {
      this.loading = true;
      const response = await this.$http.get(childTasksUrl(this.$route.params.id));
      // DEV-3302: socket updateTasks yüklemeleri sırasız dönebilir; eski yanıt yeni durumu ezmesin.
      if (!this.hashSilme.yanitGeldi(sira, response.data))
        return;
      this.items = response.data;
    } catch (e) {
      if (this.hashSilme.eskiYanitMi(sira))
        return;
      // Satırlar korunur. Toast yalnız tablo boşken: bağlantı yokken gelen socket olayları
      // toast yağmuruna dönmesin.
      if (this.items.length === 0)
        this.$toast.error("İşlemler getirilirken hata oluştu. " + e.message);
    } finally {
      if (this.hashSilme.sonIstekMi(sira))
        this.loading = false;
    }
  }

  deleteHash(item: ITask): Promise<void> {
    return hashKaydiniSil(this.$http, this.$toast, gorevHash(item));
  }

  // DeleteDialog @success: aynı hash'li hatalı satırlar hemen gizlenir, sunucu doğrusu load() ile gelir.
  hashSilindi(item: ITask): void {
    this.hashSilme.silindi(item, this.items);
    this.load();
  }

  getTarafAdi(taraf: TarafKisi | TarafKurum, rolOlsun: boolean = false): string {
    let ad = taraf.kisiMi ?
        ((taraf.temelBilgileri.adi + " " + taraf.temelBilgileri.soyadi) || taraf.adSoyad) :
        (taraf.temelBilgileri.kurumAdi || taraf.kurumAdi)
    return (rolOlsun ? (taraf.tarafSifati.rolAdi + " ") : "") + ad;
  }

  downloadExcel() {
    this.downloading = true;
    this.$helper.download('Excel Sonuçlar.xlsx', '/api/v1/export-to-excel/' + this.$route.params.id).finally(() => {
      this.downloading = false;
    });
  }

  tarihiFormatla(tarih: string): string {
    const parts = tarih.split(' ');
    const dateParts = parts[0].split('/');
    const timeParts = parts[1].split(':');
    return `${dateParts[2]}-${dateParts[1]}-${dateParts[0]}T${timeParts.join(':')}`;
  }

  async topluTTIndir() {
    this.ttDownloading = true;
    try {
      const params = this.items
        .filter((item: ITask) => item.status == this.taskDurum.BITTI_BASARILI)
        .map((item: ITask) => ({
          birimId: item.response.tevziBilgileri.birimID,
          acilisTime: new Date(this.tarihiFormatla(item.response.tevziBilgileri.dosyaAcilisTarihi)).getTime(),
          dosyaAcilisTarihi: item.response.tevziBilgileri.dosyaAcilisTarihi
        }));
      const dosyalar: Array<TamamlanmayanDosyalarRow> = await this.$uyap.TamamlanmayanDosyaBul().runToplu(params, true);
      const uyapIdleri = dosyalar.map((item: TamamlanmayanDosyalarRow) => ({
        dosyaId: item.dosyaID,
        birimAdi: item.birimAdi,
        esasNo: item.dosyaNo ?? ''
      }));
      await this.$uyapHelper.topluTakipTalebiIndir(uyapIdleri);
    } catch (e) {
      console.error('topluTTIndir Error', e.message);
    } finally {
      this.ttDownloading = false;
    }
  }

  async durdurDevamEt() {
    if (this.$store.getters.getPlayerDurum == this.playerDurum.oto) {
      this.$socket.client.emit("player", this.playerDurum.durduruluyor);
    } else {
      this.$socket.client.emit("player", this.playerDurum.oto);
    }
  }

  selectAllToggle() {
    let tamamlananlar = this.items.filter((item: ITask) => item.status == this.taskDurum.BITTI_BASARILI);
    if (this.seciliGorevler.length == tamamlananlar.length) {
      this.seciliGorevler = [];
    } else {
      this.seciliGorevler = tamamlananlar;
    }
  }

  createTask() {
    if (this.seciliGorevler.length > 0) {
      let tasks: Array<Task> = [];
      this.seciliGorevler.forEach((item: any) => {
        let task: Task = new Task();
        task.birim_adi = item.response.tevziBilgileri.birimAdi ?? "";
        task.dosya_id = item.dosyaID;
        task.task_type_id = TaskTuru.mts_takip_ac;
        task.data = item.response;
        tasks.push(task);
      });
      this.$store.dispatch('postTasks', tasks).then(() => {
        this.$router.push(this.programPaths.eicrapro + '/islemler');
      });
    }
  }

  selectAllErrorsToggle() {
    // DEV-3302: yalnız tablodaki hatalı satırlar seçilir. Hazırla görevinde BITTI_EKSIK = takip UYAP'ta
    // açılmış (harç muaf) ama hash kaydı güncellenememiş; görünmeden seçilip yeniden tevziye giderse
    // aynı borç için ikinci takip açılabilir.
    let hatalilar = this.items.filter((item: ITask) => item.status == this.taskDurum.BITTI_HATALI);
    if (this.seciliHataliGorevler.length == hatalilar.length) {
      this.seciliHataliGorevler = [];
    } else {
      this.seciliHataliGorevler = hatalilar;
    }
  }

  async tryAgainCreateTask() {
    if (this.seciliHataliGorevler.length > 0) {
      this.onFly = true;
      let tasks: Array<ITask> = [];
      this.seciliHataliGorevler.forEach((item: any) => {
        let task: ITask = {...item};
        task.id = null;
        task.status = TaskDurum.SIRADA;
        task.response = null;
        task.parent_id = null;
        tasks.push(task);
      });
      tasks[0].aciklama = tasks[0].data.xmlName + " XML'indeki hatalı takiplerin yeniden tevzi alınması."
      try {
        await this.$store.dispatch('postTasks', tasks);
        let req = {
          ids: this.seciliHataliGorevler.map((gorev: ITask) => gorev.id),
          status: TaskDurum.YENIDEN_BASLATILDI
        };
        await this.$http.post('/api/v1/task/update-status', req);
        await this.$store.dispatch('getTasksFromServer');
        await this.load();
        await this.$router.push(ProgramPaths.eicrapro + '/islemler');
      } catch (e) {
        console.error(e)
      } finally {
        this.seciliHataliGorevler = [];
        this.onFly = false;
      }
    } else {
      this.$toast.info('Yeniden başalatılacak görevleri seçiniz.')
    }
  }
}
